import { render, staticRenderFns } from "./RegularHelpPage.vue?vue&type=template&id=6ccd9875&"
import script from "./RegularHelpPage.vue?vue&type=script&lang=js&"
export * from "./RegularHelpPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports